import { isDate } from 'date-fns';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { translationModules } from 'virtual:resq-translation-modules';
import { TimestampFormat, formatTimestamp } from './helpers/datetime';
import { createTranslationBackend } from './i18n/translationBackend';

const FALLBACK_LANGUAGE = 'en-CA';
const BOOT_NAMESPACES = ['translation', 'validation'] as const;
const translationBackend = createTranslationBackend(translationModules);

export const ensureI18NextLanguage = async (language: string): Promise<void> => {
    if (!language || !i18n.isInitialized) {
        return;
    }

    await i18n.loadLanguages(language);
};

export const configureI18Next = async (): Promise<void> => {
    // i18n is being added here only as a proof-of-concept.
    // TODO:
    // 1. Figure out a way to namespace the keys (e.g. "facilities.details.facilityDetails.provinceLabel").
    // 2. Add en-US translations where appropriate.
    await i18n
        .use(LanguageDetector)
        .use(translationBackend)
        .use(initReactI18next)
        .init({
            // Our translation resources use i18next v4 plural keys (`*_one`, `*_other`), so we must
            // use v4 JSON compatibility. v3 mode ignores those keys.
            compatibilityJSON: 'v4',
            fallbackLng: FALLBACK_LANGUAGE,
            load: 'currentOnly',
            ns: BOOT_NAMESPACES,
            defaultNS: 'translation',
            interpolation: {
                escapeValue: false,
                format: (value, _format) => {
                    if (isDate(value)) {
                        const idx = Object.keys(TimestampFormat).indexOf(_format || '');
                        const f = Object.values(TimestampFormat)[idx] ?? TimestampFormat.DATE;
                        return formatTimestamp(value, f);
                    }
                    return value;
                },
            },
            nsSeparator: false,
        });
};
